/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const Signature = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 21 21">
      <path
        d="M0 2.4C0 1.07625 1.07625 0 2.4 0H8.00625C8.64375 0 9.255 0.25125 9.705 0.70125L13.695 4.69875C14.145 5.14875 14.3963 5.76 14.3963 6.3975V10.0538L9.44625 15.0038H7.8675L7.26375 12.9938C7.0875 12.405 6.5475 12.0038 5.9325 12.0038C5.50875 12.0038 5.11125 12.195 4.84875 12.525L2.595 15.3375C2.28375 15.7238 2.3475 16.2938 2.73375 16.6013C3.12 16.9088 3.69 16.8488 3.9975 16.4587L5.76375 14.2538L6.33375 16.155C6.44625 16.5375 6.79875 16.7963 7.19625 16.7963H8.3775C8.34375 16.9125 8.31375 17.0325 8.29125 17.1525L7.8825 19.1963H2.4C1.07625 19.1963 0 18.12 0 16.7963V2.39625V2.4ZM7.8 2.19375V5.7C7.8 6.19875 8.20125 6.6 8.7 6.6H12.2063L7.8 2.19375ZM10.0575 17.5088C10.1512 17.0438 10.38 16.6163 10.7137 16.2825L15.1725 11.8237L18.1725 14.8238L13.7137 19.2825C13.38 19.6163 12.9525 19.845 12.4875 19.9388L10.2525 20.385C10.2188 20.3925 10.1813 20.3963 10.1438 20.3963C9.84375 20.3963 9.59625 20.1525 9.59625 19.8488C9.59625 19.8113 9.6 19.7775 9.6075 19.74L10.0538 17.505L10.0575 17.5088ZM20.1 12.8963L19.02 13.9763L16.02 10.9763L17.1 9.89625C17.9287 9.0675 19.2713 9.0675 20.1 9.89625C20.9288 10.725 20.9288 12.0675 20.1 12.8963Z"
        fill="#000"
      />
    </BaseSvgIcon>
  )
}

export default Signature
